import React from 'react';

import styled from 'styled-components';

interface Props {
  secondary?: React.ReactNode;
  tertiary?: React.ReactNode;
  secondaryZindex?: string;
  tertiaryZindex?: string;
  children: React.ReactNode;
  mainZindex?: string;
  scrollable?: boolean;
  mainContentClass?: string;
  type: 'horizontal' | 'vertical';
}

export const FlexPanel = ({
  children,
  secondary,
  tertiary,
  type,
  scrollable = false,
  mainContentClass = '',
  secondaryZindex = '1',
  tertiaryZindex = '1',
  ...other
}: Props): JSX.Element => (
  <StyledFlexPanelDiv
    type={type}
    scrollable={scrollable}
    secondaryZindex={secondaryZindex}
    tertiaryZindex={tertiaryZindex}
    {...other}
  >
    {secondary && <div className="secondary">{secondary}</div>}
    <div className={`main ${mainContentClass}`}>{children}</div>
    {tertiary && <div className="tertiary">{tertiary}</div>}
  </StyledFlexPanelDiv>
);

type StyledFlexPanelDivProps = Pick<
  Props,
  'type' | 'secondaryZindex' | 'scrollable' | 'mainZindex'
> & {
  tertiaryZindex?: string;
};

const StyledFlexPanelDiv = styled.div.attrs<StyledFlexPanelDivProps>({
  className: 'print-overflow-force',
})<StyledFlexPanelDivProps>`
  flex-grow: 1;
  display: flex;
  flex-direction: ${({type}) => (type === 'vertical' ? 'column' : 'row')};
  align-items: stretch;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  > .secondary {
    z-index: ${({secondaryZindex}) => secondaryZindex};
    flex: 0 0 auto;
    position: relative;
    -webkit-overflow-scrolling: touch;
  }

  > .tertiary {
    z-index: ${({tertiaryZindex}) => tertiaryZindex};
    flex: 0 0 auto;
    position: relative;
    -webkit-overflow-scrolling: touch;
  }

  > .main {
    position: relative;
    overflow: ${({scrollable}) => (scrollable === true ? 'auto' : 'hidden')};
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    flex: 1 1 auto;
    z-index: ${({mainZindex}) => mainZindex || 'auto'};
  }
`;
